import React, { useState } from 'react'
import { IoIosArrowForward } from "react-icons/io";
import { FiEyeOff } from "react-icons/fi";
import { IoEyeOutline } from "react-icons/io5";
import { FaKey } from "react-icons/fa";
import { FaUser } from "react-icons/fa";


function Password() {

    const [currentPassword, setcurrentPassword] = useState('')
    const [newPassword, setnewPassword] = useState('')
    const [ConfirmPassword, setConfirmPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [showprogrssbar, setshowprogrssbar] = useState(false)

    const checks = {
        lowerUpper: /(?=.*[a-z])(?=.*[A-Z])/.test(newPassword),
        number: /(?=.*\d)/.test(newPassword),
        special: /(?=.*[!#$%@^&*])/.test(newPassword),
        length: newPassword.length >= 8
    };

    const getStrength = () => {
        let score = 0;
        if (checks.lowerUpper) score++;
        if (checks.number) score++;
        if (checks.special) score++;
        if (checks.length) score++;

        if (score <= 1) return { text: "Weak", width: "25%", color: "bg-red-500" };
        if (score === 2 || score === 3) return { text: "Medium", width: "60%", color: "bg-yellow-500" };
        if (score === 4) return { text: "Strong", width: "100%", color: "bg-green-600" };
    };

    const strength = getStrength();

    const isMatch = newPassword && ConfirmPassword && newPassword === ConfirmPassword;
    
    function updatepassword() {
       
       if ( newPassword == '' ) {
            alert('Enter New Password')
            return;
        }
       else if ( ConfirmPassword == '') {
            alert(' Enter Confirm Password')
            return;
        }

        const NeWpassword = {
            Oldpassword: currentPassword,
            NewPassword: newPassword,
        }
        isMatch ?  console.log(NeWpassword) : alert('Confirm Password is not Match ')
        setConfirmPassword('')
        setnewPassword('')
    }

    return (
        <>
            <div className='pt-[70px] pb-[50px] px-4 min-h-screen dark:bg-[#121519]'>

                <div className='border-b-[1px] border-[#cfcdcd] pb-1'>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>Change Password</h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer gap-1'>
                        <span>Home</span> <IoIosArrowForward />
                        <span>Change Password</span>
                    </div>
                </div>

                <div className='w-[100%] flex flex-wrap mt-4'>
                    <div className='sm:w-[50%] w-[100%]'>

                        {/* Current Password */}
                        <div className='w-[100%]'>
                            <label className='text-[#000] text-[12px] font-semibold'>Current Password</label>

                            <div className='w-[100%] text-[#576071] flex justify-between border-[#576071] border-[1px] p-2 rounded-md items-center'>
                                <input
                                    type='password'
                                    value={currentPassword}
                                    onChange={(e) => setcurrentPassword(e.target.value)}
                                    className='outline-none text-[#454546] text-[12px] font-semibold bg-[#fff0] w-[100%]'
                                />
                                <FaKey />
                            </div>
                        </div>

                        {/* New Password */}
                        <div className='w-[100%] mt-2'>
                            <label className='text-[#000] text-[12px] font-semibold'>New Password</label>

                            <div className='w-[100%] text-[#576071] flex justify-between border-[#576071] border-[1px] p-2 rounded-md items-center'>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={newPassword}
                                    onChange={(e) => {
                                        setnewPassword(e.target.value)
                                        setshowprogrssbar(true)
                                    }}
                                    className='outline-none text-[#454546] text-[12px] font-semibold bg-[#fff0] w-[100%]'
                                    maxLength={15}
                                />

                                {showPassword ? (
                                    <IoEyeOutline onClick={() => setShowPassword(!showPassword)} className='cursor-pointer ml-2' />
                                ) : (
                                    <FiEyeOff onClick={() => setShowPassword(!showPassword)} className='cursor-pointer ml-2' />
                                )}
                            </div>

                            {showprogrssbar &&
                                <div className="w-full mt-2">
                                    <div className="w-full h-[6px] bg-gray-300 rounded">
                                        <div className={`h-[6px] rounded ${strength?.color}`} style={{ width: strength?.width }}> </div>
                                    </div>
                                    <p className="text-[12px] mt-1 font-semibold">{strength?.text}</p>
                                </div>
                            }
                        </div>

                        {/* Confirm Password */}
                        <div className='w-[100%] mt-2'>
                            <label className='text-[#000] text-[12px] font-semibold'>Confirm Password</label>

                            <div className='w-[100%] text-[#576071] flex justify-between border-[#576071] border-[1px] p-2 rounded-md items-center '>
                                <input
                                    type='password'
                                    value={ConfirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    className='outline-none text-[#454546] text-[12px] font-semibold bg-[#fff0] w-[100%]'
                                />
                                <FaKey />
                            </div>

                            {/* ✅ Match Status */}
                            {ConfirmPassword && (
                                <span className={`text-[12px] font-semibold ${isMatch ? "text-green-600" : "text-red-500"}`}>
                                    {isMatch ? "✔ Passwords match" : "✖ Passwords do not match"}
                                </span>
                            )}
                        </div>
                        <button
                            onClick={() => updatepassword()}
                            className='p-2 bg-[#00816a] rounded-md text-[12px] flex items-center gap-1 font-semibold text-[#fff] mt-4'>
                            <FaUser /> Update Now
                        </button>
                    </div>
                    <div className='sm:w-[50%] w-[100%] flex items-center justify-center'>
                        <div className="text-[14px] font-semibold mt-2 space-y-1">
                            <p className={checks.lowerUpper ? "text-green-600" : "text-red-500"}>
                                {checks.lowerUpper ? "✔" : "✖"} At least one lowercase & uppercase
                            </p>
                            <p className={checks.number ? "text-green-600" : "text-red-500"}>
                                {checks.number ? "✔" : "✖"} At least one number (0-9)
                            </p>
                            <p className={checks.special ? "text-green-600" : "text-red-500"}>
                                {checks.special ? "✔" : "✖"} At least one special character (!#$%^&*)
                            </p>
                            <p className={checks.length ? "text-green-600" : "text-red-500"}>
                                {checks.length ? "✔" : "✖"} Minimum 8 characters
                            </p>
                        </div>
                    </div>
                </div> 
            </div>
        </>
    )
}

export default Password